export default __webpack_public_path__ + "static/media/chatIllustration.32d6c805.webp";